import { render, staticRenderFns } from "./ViewAttachmentst.vue?vue&type=template&id=27dca654&scoped=true"
import script from "./ViewAttachmentst.vue?vue&type=script&lang=js"
export * from "./ViewAttachmentst.vue?vue&type=script&lang=js"
import style0 from "./ViewAttachmentst.vue?vue&type=style&index=0&id=27dca654&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dca654",
  null
  
)

export default component.exports